module.exports = __webpack_public_path__ + "img/0d84a11.jpg";